import { render, staticRenderFns } from "./ImagenPreview.vue?vue&type=template&id=030873a6&scoped=true"
import script from "./ImagenPreview.vue?vue&type=script&lang=js"
export * from "./ImagenPreview.vue?vue&type=script&lang=js"
import style0 from "./ImagenPreview.vue?vue&type=style&index=0&id=030873a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030873a6",
  null
  
)

export default component.exports